import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Controla la apertura/cierre del modal "Solicitar una demo" desde cualquier componente. */
@Injectable({ providedIn: 'root' })
export class DemoModalService {
  private readonly _open = new BehaviorSubject<boolean>(false);
  readonly open$ = this._open.asObservable();

  open(): void {
    this._open.next(true);
  }

  close(): void {
    this._open.next(false);
  }
}
